import { gConsts  } from '@/globals/gConsts';
import { projects } from './projects';

/* 
    apps.json
        Estrutura de dados interna com definições de cada [App] acessado dependendo do app definido 
        no [project.JSON].info.appID.
*/
export const apps = {
    Annotations : {
        info : {
            name : 'RM Annotations',
            description : 'RM App usado para anotação interna de datasets de IA'
        }, 

        sidePanels : [
            {id : gConsts.ui.sidePanel.ids.JOBS  , label : 'Tarefas'      , icon : '💀', width : '200', side : gConsts.ui.sidePanel.sides.LEFT },
            {id : gConsts.ui.sidePanel.ids.ANNOTS, label : 'Passos'       , icon : '🦷', width : '550', side : gConsts.ui.sidePanel.sides.RIGHT},
            {id : gConsts.ui.sidePanel.ids.CONFIG, label : 'Configurações', icon : '🔧', width : '250', side : gConsts.ui.sidePanel.sides.RIGHT}
        ],

        toolbars : { 
            imgLabel : [
                { id : gConsts.ui.toolbar.buttons.IMG_LABEL, annotTool : gConsts.tool.attrib.types.NO_TOOL, img : 'label.gif', hint : 'Liga/desliga a ferramenta de labels para a imagem.' },
            ],
        },

        projects : projects.Annotations,
    },

    TomoNav : {
        info : {
            name : 'RM TomoNav',
            description : 'App da RM usada navegação de tomografias'     
        }, 

        sidePanels : [],  // TomoNav é praticamente o RM Interact (depois que eu trouxer pages com elementos pra cá).

        projects : projects.TomoNav,
    }, 

    RadioBot : {
        info : {
            name : 'RM RadioBot',
            description : 'App da RM usada para realização de laudos assistidos por IA'     
        }, 

        sidePanels : [
            { id: gConsts.ui.sidePanel.ids.JOBS  , label: 'Tarefas'      , icon: '💀', width: 350, side: gConsts.ui.sidePanel.sides.LEFT , comp: 'imgListCMP'     },
            // { id: gConsts.ui.sidePanel.ids.ANNOTS, label: 'Anotações'    , icon: '🦷', width: 600, side: gConsts.ui.sidePanel.sides.RIGHT, comp: 'annotationsCMP' },
            { id: gConsts.ui.sidePanel.ids.RELATORIO_DINAMICO, label: 'Laudo Radiográfico', icon: '📄', width: 600, side: gConsts.ui.sidePanel.sides.RIGHT, comp: 'relatorioDinamicoCMP'},
            { id: gConsts.ui.sidePanel.ids.ANNOTS, label: 'Anotações'    , icon: '🦷', width: 600, side: gConsts.ui.sidePanel.sides.RIGHT, comp: 'novoAnotacoesCMP' },
            // { id: gConsts.ui.sidePanel.ids.REPORT, label: 'Relatório'    , icon: '📄', width: 700, side: gConsts.ui.sidePanel.sides.RIGHT, comp: 'relatorioCMP'   },
            { id: gConsts.ui.sidePanel.ids.CONFIG, label: 'Configurações', icon: '🔧', width: 250, side: gConsts.ui.sidePanel.sides.RIGHT, comp: 'configCMP'      },
        ],

        toolbars : {
            imgTools : [
                { id : gConsts.ui.toolbar.buttons.WA_PAN    , icon: 'move-cursor-image', img : 'pan.gif'        , hint : 'Arrastar a imagem (apertar a tecla CTRL para ativar a qualquer momento)' },
                { id : gConsts.ui.toolbar.buttons.IMG_BC    , icon: 'brightness-contrast-image', img : 'bc.svg'         , hint : 'Alterar o brilho e contraste da imagem (atalho: SHIFT / click com botão direito para resetar)' },
                { id : gConsts.ui.toolbar.buttons.IMG_ORIGIN, img : 'imgOrigin.gif'  , hint : 'Mostrar a imagem origem da imagem corrente (se houver alguma)' },
                { id : gConsts.ui.toolbar.buttons.FIT_TO_WA , icon: 'fit-to-screen-image', img : 'fittoscreen.gif', hint : 'Ajustar a imagem ao espaço disponível' },
                // { id : gConsts.ui.toolbar.buttons.SAVE_IMG  , icon: 'save-image', img : 'save.gif'       , hint : 'Salva anotações da imagem corrente (dispara automáticamente quando muda a imagem)' },
                { id : gConsts.ui.toolbar.buttons.CROSS_HAIR, icon: 'crosshair-image', img : 'crossHair.gif'  , hint : 'Ligar/desligar a cruz/alvo do mouse' },
            ],

            iaTools : [
                { id : gConsts.ui.toolbar.buttons.FIX_SEGMENTACAO_DENTE, icon: 'fix-segmentacao-dente', img : 'fix-segmentacao-dente.svg', hint : 'Corrigir segmentação de dentes' },
            ],

            undoRedo : [
                // { id : gConsts.ui.toolbar.buttons.UNDO, icon: 'back-undoredo', img : 'Voltar.png' , hint : 'Volta/cancela a última ação realizada' },
                // { id : gConsts.ui.toolbar.buttons.REDO, icon: 'forward-undoredo', img : 'Avancar.png', hint : 'Refaz a última ação cancelada' },
            ],

            annotTools : [
                { id : gConsts.ui.toolbar.buttons.PONTO        , icon: 'ponto-anotacao', img : 'btPonto.gif'    , hint : 'Inserção de ponto na imagem' },
                { id : gConsts.ui.toolbar.buttons.RETA         , icon: 'reta-anotacao', img : 'btReta.gif'     , hint : 'Inserção de reta na imagem' },
                { id : gConsts.ui.toolbar.buttons.RETANGULO    , icon: 'retangulo-anotacao', img : 'btRetangulo.gif', hint : 'Inserção de retângulo na imagem' },
                { id : gConsts.ui.toolbar.buttons.CIRCULO      , icon: 'circulo-anotacao', img : 'btCirculo.gif'  , hint : 'Inserção de círculo na imagem' },
                { id : gConsts.ui.toolbar.buttons.RETANGULO_INC, icon: 'retangulo-inc-anotacao', img : 'btRet_inc.gif'  , hint : 'Inserção de retângulo inclinado na imagem (desenha 1o a linha superior inclinada e depois define a altura).' },
                { id : gConsts.ui.toolbar.buttons.PATH         , icon: 'path-anotacao', img : 'btPath.gif'     , hint : 'Inserção de polígono na imagem ... clique do botão direito para terminar.' },
                { id : gConsts.ui.toolbar.buttons.CURVA        , icon: 'curva-anotacao', img : 'btCurva.gif'    , hint : 'Inserção de uma curva na imagem ... clique do botão direito para terminar.' },
                { id : gConsts.ui.toolbar.buttons.DEL_TOOL     , icon: 'delete-anotacao', img : 'btDelTool.gif'  , hint : 'Apagar a anotação corrente' },
            ],

            other : [
                // { id : gConsts.ui.toolbar.buttons.EXEC_MODE  , img : 'execMode.png'  , hint : 'Liga/desliga o modo de visualização do exame (modo dentista/paciente)' },
                { id : gConsts.ui.toolbar.buttons.FULL_SCREEN, icon : 'fullscreen-other', img : 'fullScreen.png', hint : 'Ligar/desligar o modo de visualização de tela cheia' },
                { id : gConsts.ui.toolbar.buttons.RESET_JOB, icon : 'reset-job', img : 'reset-job.svg', hint : 'Resetar o laudo corrente' },
            ]
        },

        projects : projects.RadioBot,
    },

    /* Será que precisa de outro app definition pro RadioBot3D ? 
       Acho que ele terá os mesmos paineis do RadioBot normal (por eqto) ... */
    RBOT3D : {},

    /* Será que nossa aba de impressão vai sair ?
         Se tiver que fazer ela aqui ... 
       * posso reativar os elems manipuláveis, 
       * adicionar um sidePanel com os elems da doc para inserção e edição de relatórios
       Basicamente trazer o RMReports pra cá ... mas dessa vez com IA pra montar os relatórios baseado na 
         classificação e nos SVGs dos templates. */
    REPORTS : {},

    /* Este formato de aplicação é muito flexivel.
        Eu poderia por ex. recriar o cefComp/iCef aqui ... basta:
        * Criar 2 passos um com 1 layer cada, uma para os pontos e outro pra as curvas.
        * Criar um sidePanel para os fatores. */
    CEFBOT : {}
};

